import { IconAcknowledgeHide } from 'common/components/Icons/IconAcknowledgeHide/IconAcknowledgeHide';
import { IconAddTag } from 'common/components/Icons/IconAddTag/IconAddTag';
import { IconRemoveTag } from 'common/components/Icons/IconRemoveTag/IconRemoveTag';
import { IconRescan } from 'common/components/Icons/IconRescan/IconRescan';
import { IconUncknowledge } from 'common/components/Icons/IconUncknowledge/IconUncknowledge';
import { PathNames } from 'common/constants/pathNames';
interface ITabset {
  [key: string]: ITab;
}
interface ITab {
  title: string;
  key: string;
  link: string;
  permissionOpen: boolean;
  active: boolean;
  showSummary?: boolean;
  columnPickerPath: string;
  gridPath: string;
  tabPath: string;
  count: number;
}

export const TABSET: ITabset = {
  open: {
    title: 'Open Action Items',
    key: 'open_action_items',
    link: '/pages/actionItems/open',
    permissionOpen: true,
    active: false,
    showSummary: true,
    columnPickerPath: PathNames.actionItemsOpenColumns,
    gridPath: PathNames.actionItemsOpen,
    tabPath: PathNames.actionItemsOpenSummary,
    count: 0
  },
  closed: {
    title: 'Closed Action Items',
    key: 'closed_action_items',
    link: '/pages/actionItems/closed',
    permissionOpen: true,
    active: false,
    showSummary: true,
    columnPickerPath: PathNames.actionItemsCloseColumns,
    gridPath: PathNames.actionItemsClose,
    tabPath: PathNames.actionItemsCloseSummary,
    count: 0
  }
};

export const OPTIONS = [
  {
    IconComponent: IconRescan,
    label: 'Rescan'
  },
  {
    IconComponent: IconAcknowledgeHide,
    label: 'Acknowledge'
  },
  {
    IconComponent: IconUncknowledge,
    label: 'Unacknowledge'
  },
  {
    IconComponent: IconAddTag,
    label: 'Add Tags',
    ff: 'isCustomTags'
  },
  {
    IconComponent: IconRemoveTag,
    label: 'Remove Tags',
    ff: 'isCustomTags'
  }
];
